import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { NgModule, ModuleWithProviders, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

import { throwIfAlreadyLoaded } from '@lib/common/helpers';
import { SnIconModule } from '@lib/ui/icon';

import { ApiRoutingModule } from './api-routing.module';
import { ConnectionRefusedComponent } from './components/connection-refused';
import { NotFoundComponent } from './components/not-found';
import { apiInitializerFactory } from './factories';
import {
  SnApiUrlInterceptor,
  ApiErrorInterceptor,
  SnApiParamsInterceptor,
  SnExponentialRetryInterceptor,
  SnLocaleInterceptor,
} from './interceptors';
import { SN_API_URL, SN_SECONDARY_API_URL } from './providers';

@NgModule({
  imports: [
    // Material
    MatSnackBarModule,
    MatButtonModule,
    // Libs
    SnIconModule,
    // Own
    ApiRoutingModule,
  ],
  declarations: [NotFoundComponent, ConnectionRefusedComponent],
  providers: [{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } }],
})
export class SnApiModule {
  public static forRoot(
    apiUrl: string,
    secondaryApiUrl?: string,
  ): ModuleWithProviders<SnApiModule> {
    return {
      ngModule: SnApiModule,
      providers: [
        {
          provide: SN_API_URL,
          useValue: apiUrl,
        },
        {
          provide: SN_SECONDARY_API_URL,
          useValue: secondaryApiUrl,
        },
        {
          provide: APP_INITIALIZER,
          useFactory: apiInitializerFactory,
          deps: [SN_API_URL, HttpClient],
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SnApiUrlInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiErrorInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SnApiParamsInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SnExponentialRetryInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SnLocaleInterceptor,
          multi: true,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: SnApiModule) {
    throwIfAlreadyLoaded(parentModule, 'SnApiModule');
  }
}
